import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  productTypeRadio: {
    display: 'inline-flex',
    position: 'relative',
    alignItems: 'flex-start',
  },

  demoBadge: {
    fontSize: 0,
    margin: '-.2rem .9375rem 0 -.8rem',
  },
})

export default useStyles
